<panel>
	<h1>{{ 'domains.change-domain-owner.header' | translate }}</h1>
	<section>
		@if (selectedCompanyId) {
			<div>
				@if (selectedCompanyInfo) {
					<strong> {{ selectedCompanyInfo.name }} </strong>
					<button [loader]="false" small (click)="selectedCompanyId = undefined; selectedCompanyInfo = undefined"><icon type="xmark" /></button>
				}
				@else { <skeleton /> }
			</div>
		}
		@else {
			<company-search (onSelected)="selectCompany($event)" [displayVatNumber]="true" />
		}
	</section>
	<section>
		<button confirm [active]="!!domainId && !!selectedCompanyId && !!currentOwner && !!selectedCompanyInfo" (click)="changeOwner()">{{ 'domains.change-domain-owner.submit' | translate }}</button>
	</section>
</panel>
